import * as cookiesNext from 'cookies-next/client';

import { type CookieManager } from '@/sdk/shared/cookieManager';

/**
 * CookieManager Client-Side is for the exclusive use of the Profile SDK and CentralizedLogin
 */
export const cookieManager: CookieManager = {
  get: (name: string) => Promise.resolve(cookiesNext.getCookie(name)),
  has: (name: string) => Promise.resolve(cookiesNext.hasCookie(name)),
  set: (options: { name: string; value: string; expiration: Date; path?: string; domain?: string }) => {
    const { name, value, expiration, path = '/', domain } = options;

    cookiesNext.setCookie(name, value, {
      domain,
      expires: expiration,
      path,
      encode(str: string) {
        return str;
      },
    });
  },
  delete: (options: { name: string; path?: string; domain?: string }) => {
    const { name, path = '/', domain } = options;

    cookiesNext.deleteCookie(name, {
      domain,
      path,
    });
  },
};
